import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SelectGeneralApplicationComponent } from 'app/modules/landing/corporate/select-general-application/select-general-application.component';

@Component({
    selector: 'application-header',
    templateUrl: './application-header.component.html',
    styleUrls: ['./application-header.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        SelectGeneralApplicationComponent,
    ],
})
export class ApplicationHeaderComponent {
    @Input() activeTab: string = 'applications';

    applicationNav = [
        {
            label: 'Recent Applications',
            value: 'applications',
        },
        {
            label: 'Past Applications',
            value: 'past-applications',
        },
    ];

    constructor(private router: Router) {}

    ngOnInit() {
        this.applicationNav.push({
            label: 'Draft',
            value: 'draft',
        });
    }

    onSelectionChange(event: any) {
        this.router.navigate([`${event}`]);
    }
}
